'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilitySetsNewCtrl', function ($scope, user, positions, me,
                                       pending_in_review_availability_sets, userAvailabilityChangeRequests,
                                       last_disapproved_availability_set, canCreateAvailabilitySet,
                                       Session, ServerUrls, $uibModal, org, SAErrorHandler,
                                       AvailabilitySets, TimeService, $state, $interval, $timeout,
                                       OverrideTokens, UserPermissionsService) {

    $scope.user = user;
    $scope.me = me;
    $scope.org = org;
    $scope.pending_in_review_availability_sets = pending_in_review_availability_sets;
    $scope.userAvailabilityChangeRequests = userAvailabilityChangeRequests;

    $scope.isSuperUser = false;
    $scope.needToken = !$scope.org.organization_config.can_change_availability &&
                       !($scope.userAvailabilityChangeRequests && $scope.userAvailabilityChangeRequests.length > 0);

    $scope.state = {
      selectedSet: undefined,
      selectedSetName: 'current',
      currentSlide: 0,
      newState: 0
    };

    var permissionsToLookUp = [
      'availability_sets.create_override'
    ];

    $scope.overrideToken = null;
    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.isSuperUser = dikt['availability_sets.create_override'];
        if (!$scope.needToken || $scope.isSuperUser) {
          $scope.canChangeAvailability = true;
        } else if ($scope.needToken) {

          OverrideTokens.getOne({
            user_id: $scope.user.id,
            organization_id: $scope.org.id,
            token_type: 'Availability'
          }).then(function(token) {
            $scope.overrideToken = token;
            $scope.canChangeAvailability = !!token;
          }, function(response) {
            console.log('Failed to load override token', response);
          });

        }
      });

    $scope.lastDisapprovedSet = _.first(last_disapproved_availability_set);

    $scope.currentSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && availSet.$isInEffect() && availSet.active;
    });

    $scope.futureSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && !availSet.$isInEffect() && availSet.active;
    });

    $scope.inReviewSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isInReview() && availSet.active;
    });

    $scope.pendingSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isPending() && availSet.active;
    });

    $scope.active_uacr = _.find($scope.userAvailabilityChangeRequests, function(uacr) {
      return !uacr.$isExpired();
    });

    $scope.hasASetToStartWith = false;

    if ($scope.currentSet || $scope.futureSet || $scope.inReviewSet || ($scope.pendingSet && $scope.pendingSet.availability_rules.length > 0) || ($scope.lastDisapprovedSet && $scope.lastDisapprovedSet.availability_rules.length > 0)) {
      $scope.hasASetToStartWith = true;
    }

    $scope.meHasMadeAvailabilitySet = _.any($scope.me.availability_sets, function(availSet) {
      return availSet.user_id === $scope.me.id;
    });


    $scope.editSet = function(availSet) {
      $state.go('profile.availability.sets.edit', {setId: availSet.id});
    };

    $scope.createSet = function() {
      var availSet = $scope.state.selectedSet;

      if (_.isUndefined(availSet)) {
        availSet = null;
      }

      var newSetData = {
        desired_effective_date: moment($scope.formData.desiredEffectiveDate).toISOString(),
        organization_id: $scope.org.id,
        user_id: $scope.user.id,
        availability_rule_ids: [],
        state: 0,
        message: $scope.formData.comment
      };

      var active_uacr = _.find($scope.userAvailabilityChangeRequests, function(uacr) {
        return !uacr.$isExpired();
      });

      if (active_uacr) {
        newSetData.user_availability_change_request_id = active_uacr.id;
      }


      if (!_.isNull(availSet)) {
        newSetData.availability_rule_ids = _.pluck(availSet.availability_rules, 'id');

        // go ahead and get desired_hours from the set we're starting with. Why not?
        if (availSet.desired_hours) {
          newSetData.desired_hours = availSet.desired_hours;
        }
      }

      AvailabilitySets.create(newSetData)
          .then(function(availSet) {
            console.log('created availability set');
            console.log(availSet);

            $state.go('profile.availability.sets.edit', {setId: availSet.id});

          }, function() {

          });
    };


    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.dayStartHour = $scope.org.organization_config.work_day_start_hour;

    $scope.datepickers = {
      expiresInDateOpened: false
    };

    $scope.openExpiresInDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.expiresInDateOpened === true) {
        $scope.datepickers.expiresInDateOpened = false;
      } else {
        $scope.datepickers.expiresInDateOpened = true;
      }
    };

    $scope.today = moment()
    $scope.minDate = new Date(moment().hours(0).minutes(0).seconds(0).milliseconds(0).add(moment().tz(Session.getTimezone())._offset, 'minutes').format('YYYY-MM-DD hh:mm'));

    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      showWeeks: false
    };

    $scope.formData = {
      desiredEffectiveDate: moment().tz(Session.getTimezone()).hours($scope.dayStartHour || 0).minutes(0).seconds(0).milliseconds(0).add(0, 'days').toDate(),
      comment: '',
      desired_hours: 20,
      target_hours: 20
    };

    $scope.desiredEffectiveDateMoment = moment($scope.formData.desiredEffectiveDate)

    if ($scope.active_uacr) {
      $scope.formData.desiredEffectiveDate = $scope.active_uacr.availability_change_request.effective_date.toDate();
      $scope.desiredEffectiveDateMoment = moment($scope.formData.desiredEffectiveDate)
    }


    $scope.chooseImmediately = function() {
      $scope.formData.desiredEffectiveDate = moment().add(0, 'days').toDate();

      if ($scope.hasASetToStartWith) {
        $scope.goToNext();
      } else {
        $scope.createSet();
      }

    };

    $scope.$watch('formData.desiredEffectiveDate', function (newVal, oldVal) {
      if (newVal != oldVal) {
        $scope.desiredEffectiveDateMoment = moment(newVal)
      }
    })

    $scope.chooseFuture = function() {
      $scope.formData.desiredEffectiveDate = moment().add(7, 'days').hours($scope.dayStartHour || 0).minutes(0).seconds(0).milliseconds(0).toDate();
    };

    $scope.pickSet = function(setName) {
      $scope.state.selectedSetName = setName;
      if (setName === 'blank') {
        $scope.state.selectedSet = null;
      } else {
        $scope.state.selectedSet = $scope[setName];
      }
    };

    $scope.sectionTitles = [
      {
        name: 'Intro',
        className: 'start'
      },
      {
        name: 'Set Date',
        className: 'when'
      },
      {
        name: 'Which Set',
        className: 'which'
      },
      {
        name: 'Unavailable',
        className: 'unavailable'
      },
      {
        name: 'Reasons',
        className: 'reasons'
      },
      {
        name: 'Available',
        className: 'available'
      },
      {
        name: 'Prefer',
        className: 'prefer'
      },
      {
        name: 'Review',
        className: 'review'   // include employee desired hours
      }
    ];


    // if they canCreateAvailabilitySet then they must be a manager-type, so let them skip the first page
      $scope.state.currentSlide = (canCreateAvailabilitySet && $scope.meHasMadeAvailabilitySet) ? 1 : 1;
      $scope.state.newSlide = (canCreateAvailabilitySet && $scope.meHasMadeAvailabilitySet) ? 1 : 1;

      $scope.goToNext = function() {
        $scope.goToState($scope.state.currentSlide + 1);
      };

      $scope.goToPrev = function() {
        $scope.goToState($scope.state.currentSlide - 1);
      };

      var transitionTimeout;
      var animationTimeout;


      var detectTemplateLoadedInterval = $interval(function() {
        if( $('.slide-wrapper').length > 0 ) {
          $scope.goToState($scope.state.currentSlide, true);
        }
      }, 10);

      $scope.goToState = function(newState, goNow) {
        //console.log(newState, goNow);
        if (newState < 0) {
          newState = 0;
        }

        $scope.state.newSlide = newState;

        if (!_.isUndefined(detectTemplateLoadedInterval)) {
          $interval.cancel(detectTemplateLoadedInterval);
          detectTemplateLoadedInterval = undefined;
        }

        // Wait for a small amount of time before animating to
        // allow the target slide directive to instantiate
        animationTimeout = $timeout(function () {
          if (!_.isUndefined(goNow)) { // If we loaded to a specific state, do not animate
            $('.slide-wrapper').css({
              left: newState * -823
            });
          } else { // If we clicked a button, animate
            $('.slide-wrapper').animate({
              left: newState * -823
            }, 300);
          }
        }, 50);

        // Create transitioning timer so current slide doesn't
        // disappear at start of animation
        if (!_.isUndefined(transitionTimeout)) {
          $timeout.cancel(transitionTimeout);
        }
        transitionTimeout = $timeout(function () {
          $scope.state.currentSlide = newState;
        }, 300);

      };

      $scope.displaySlide = function(slide) {
        return $scope.state.currentSlide === slide || $scope.state.newSlide === slide;
      };

      $scope.openPolicyModal = function () {
        $uibModal.open({
          size: 'policy',
          templateUrl: 'views/availabilityPolicyModal.html',
          controller: 'availabilityPolicyModal',
          controllerAs: 'availabilityPolicyModal',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                org: $scope.org,
                canEdit: false
              };
            }
          }
        })
      }

      $scope.pickSet('blank')
  });

